<template>
  <div class="view-container">
    <div class="search-panel">
      <div class="search-row">
        <div class="search-item"><label>用户名</label><input v-model="searchForm.userName" class="form-control" placeholder="搜索用户"></div>
        <div class="search-item"><label>设备平台</label><select v-model="searchForm.platform" class="form-control"><option value="">全部</option><option value="iOS">iOS</option><option value="Android">Android</option></select></div>
        <div class="search-item"><label>状态</label><select v-model="searchForm.status" class="form-control"><option value="">全部</option><option value="online">在线</option><option value="offline">离线</option></select></div>
        <div class="search-actions">
          <button @click="handleSearch" class="btn btn-primary"><i class="fas fa-search"></i> 查询</button>
          <button @click="resetSearch" class="btn btn-default"><i class="fas fa-undo"></i> 重置</button>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="table-container">
        <table class="data-table">
          <thead><tr>
            <th width="50">ID</th><th>用户</th><th width="130">设备名称</th><th width="80">平台</th><th width="120">系统版本</th><th>APP版本</th>
            <th width="70">推送Token</th><th width="80">绑定时间</th><th width="70">最后在线</th><th width="70">状态</th><th width="100">操作</th>
          </tr></thead>
          <tbody>
            <tr v-for="d in paginatedData" :key="d.id">
              <td>{{ d.id }}</td>
              <td><div class="user-cell"><div class="avatar" :style="{ background: d.color }">{{ d.avatar }}</div><span class="user-name">{{ d.userName }}</span></div></td>
              <td><i class="fas fa-mobile-alt"></i> {{ d.deviceName }}</td>
              <td><span class="platform-badge" :class="d.platform">{{ d.platform }}</span></td>
              <td>{{ d.osVersion }}</td>
              <td><span class="version-tag">v{{ d.appVersion }}</span></td>
              <td><span class="token-text">{{ d.pushToken }}</span></td>
              <td class="time-cell">{{ d.bindTime }}</td>
              <td class="time-cell">{{ d.lastOnline }}</td>
              <td><span class="online-dot" :class="d.status"></span> {{ d.status === 'online' ? '在线' : '离线' }}</td>
              <td class="action-cell">
                <button @click="pushTest(d)" class="btn btn-info btn-xs"><i class="fas fa-bell"></i></button>
                <button @click="unbindDevice(d)" class="btn btn-danger btn-xs"><i class="fas fa-unlink"></i></button>
              </td>
            </tr>
            <tr v-if="paginatedData.length===0"><td colspan="11" class="empty-cell">暂无设备数据</td></tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-row">
        <div class="pagination-info">共 {{ totalCount }} 条记录</div>
        <div class="pagination-controls">
          <div class="page-size-selector"><span>每页</span><select v-model="pageSize" class="page-size-input form-control"><option :value="10">10</option><option :value="20">20</option><option :value="50">50</option></select><span>条</span></div>
          <button @click="prevPage" :disabled="currentPage===1" class="btn btn-default btn-sm pagination-btn"><i class="fas fa-chevron-left"></i></button>
          <div class="page-numbers"><button v-for="p in visiblePages" :key="p" @click="goToPage(p)" :class="['page-btn',{active:currentPage===p,disabled:p==='...'}]" :disabled="p==='...'">{{ p }}</button></div>
          <button @click="nextPage" :disabled="currentPage>=totalPages" class="btn btn-default btn-sm pagination-btn"><i class="fas fa-chevron-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed } from 'vue'

const currentPage = ref(1); const pageSize = ref(10)
const searchForm = reactive({ userName: '', platform: '', status: '' })

const devices = ref([
  { id: 1, userName: '张三', avatar: '张', color: '#3b82f6', deviceName: 'iPhone 15 Pro Max', platform: 'iOS', osVersion: 'iOS 18.2', appVersion: '3.2.1', pushToken: '已注册', bindTime: '2026-01-15', lastOnline: '2分钟前', status: 'online' },
  { id: 2, userName: '李四', avatar: '李', color: '#10b981', deviceName: '华为 Mate 60 Pro', platform: 'Android', osVersion: 'HarmonyOS 4.0', appVersion: '3.2.0', pushToken: '已注册', bindTime: '2026-02-20', lastOnline: '10分钟前', status: 'online' },
  { id: 3, userName: '王五', avatar: '王', color: '#f59e0b', deviceName: 'Xiaomi 14 Ultra', platform: 'Android', osVersion: 'HyperOS 1.0', appVersion: '3.2.1', pushToken: '未注册', bindTime: '2026-03-01', lastOnline: '5小时前', status: 'offline' },
  { id: 4, userName: '赵六', avatar: '赵', color: '#8b5cf6', deviceName: 'OPPO Find X7', platform: 'Android', osVersion: 'ColorOS 14.0', appVersion: '3.1.5', pushToken: '已注册', bindTime: '2025-06-10', lastOnline: '3天前', status: 'offline' },
  { id: 5, userName: '孙七', avatar: '孙', color: '#ef4444', deviceName: 'iPhone 14', platform: 'iOS', osVersion: 'iOS 17.6', appVersion: '3.2.1', pushToken: '已注册', bindTime: '2026-04-15', lastOnline: '刚刚', status: 'online' },
  { id: 6, userName: '周八', avatar: '周', color: '#ec4899', deviceName: 'vivo X100 Pro', platform: 'Android', osVersion: 'OriginOS 4.0', appVersion: '3.2.0', pushToken: '未注册', bindTime: '2026-05-01', lastOnline: '昨天', status: 'offline' },
  { id: 7, userName: '吴九', avatar: '吴', color: '#06b6d4', deviceName: 'iPhone 15', platform: 'iOS', osVersion: 'iOS 18.1', appVersion: '3.2.1', pushToken: '已注册', bindTime: '2026-05-15', lastOnline: '1小时前', status: 'online' }
])

const filteredData = computed(() => {
  let r = [...devices.value]
  if (searchForm.userName) r = r.filter(d => d.userName.includes(searchForm.userName))
  if (searchForm.platform) r = r.filter(d => d.platform === searchForm.platform)
  if (searchForm.status) r = r.filter(d => d.status === searchForm.status)
  return r
})
const totalCount = computed(() => filteredData.value.length)
const totalPages = computed(() => Math.ceil(totalCount.value / pageSize.value) || 1)
const paginatedData = computed(() => { const s = (currentPage.value - 1) * pageSize.value; return filteredData.value.slice(s, s + pageSize.value) })
const visiblePages = computed(() => { const ps = [], t = totalPages.value, c = currentPage.value; if (t <= 7) { for (let i = 1; i <= t; i++) ps.push(i) } else { ps.push(1); if (c > 4) ps.push('...'); for (let i = Math.max(2, c - 2); i <= Math.min(t - 1, c + 2); i++) ps.push(i); if (c < t - 3) ps.push('...'); ps.push(t) } return ps })

const handleSearch = () => { currentPage.value = 1 }
const resetSearch = () => { Object.keys(searchForm).forEach(k => searchForm[k] = ''); currentPage.value = 1 }
const prevPage = () => { if (currentPage.value > 1) currentPage.value-- }
const nextPage = () => { if (currentPage.value < totalPages.value) currentPage.value++ }
const goToPage = (p) => { if (typeof p === 'number' && p >= 1 && p <= totalPages.value) currentPage.value = p }

const pushTest = (d) => { $message.success('已向 ' + d.userName + '(' + d.deviceName + ') 发送测试推送') }
const unbindDevice = async (d) => { if (await $confirm('确定解绑 ' + d.userName + ' 的设备 ' + d.deviceName + ' 吗？')) { devices.value = devices.value.filter(x => x.id !== d.id) } }
</script>

<style scoped>
.view-container { padding: 20px; background: #fff; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); display: flex; flex-direction: column; max-height: calc(100vh - 110px); overflow: hidden; }
.search-panel { background: #f9f9f9; border: 1px solid #e7eaec; border-radius: 4px; padding: 15px; margin-bottom: 15px; flex-shrink: 0; }
.search-row { display: flex; gap: 12px; align-items: center; }
.search-item { display: flex; align-items: center; gap: 8px; }
.search-item label { font-size: 13px; color: #676a6c; font-weight: 500; white-space: nowrap; }
.search-item .form-control { padding: 6px 10px; border: 1px solid #e7eaec; border-radius: 4px; font-size: 13px; width: 180px; }
.search-actions { display: flex; gap: 10px; margin-left: auto; }

.table-wrapper { border: 1px solid #e7eaec; border-radius: 4px; overflow: hidden; display: flex; flex-direction: column; flex: 1; min-height: 0; }
.table-container { overflow-y: auto; flex: 1; }
.data-table { width: 100%; border-collapse: collapse; }
.data-table th, .data-table td { padding: 10px 12px; border-bottom: 1px solid #e7eaec; font-size: 13px; color: #676a6c; text-align: left; white-space: nowrap; }
.data-table th { background: #f5f5f5; font-weight: 600; position: sticky; top: 0; z-index: 2; }
.data-table tbody tr:hover { background: #f9fafb; }
.time-cell { color: #999; font-size: 12px; }
.empty-cell { text-align: center; padding: 40px; color: #999; }

.user-cell { display: flex; align-items: center; gap: 8px; }
.user-cell .avatar { width: 28px; height: 28px; border-radius: 50%; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 11px; font-weight: 600; flex-shrink: 0; }
.user-name { color: #374151; font-weight: 500; }
.platform-badge { display: inline-block; padding: 2px 8px; border-radius: 3px; font-size: 11px; font-weight: 500; }
.platform-badge.iOS { background: #f5f3ff; color: #7c3aed; }
.platform-badge.Android { background: #f0fdf4; color: #16a34a; }
.version-tag { background: #ede9fe; color: #7c3aed; padding: 1px 6px; border-radius: 3px; font-size: 11px; }
.token-text { font-size: 11px; color: #9ca3af; }
.online-dot { display: inline-block; width: 7px; height: 7px; border-radius: 50%; margin-right: 4px; }
.online-dot.online { background: #10b981; }
.online-dot.offline { background: #d1d5db; }

.pagination-row { display: flex; justify-content: space-between; align-items: center; padding: 12px 15px; background: #f9f9f9; border-top: 1px solid #e7eaec; flex-shrink: 0; }
.pagination-info { font-size: 13px; color: #676a6c; }
.pagination-controls { display: flex; align-items: center; gap: 10px; }
.page-numbers { display: flex; gap: 5px; }
.page-btn { width: 32px; height: 32px; border: 1px solid #e7eaec; background: #fff; color: #676a6c; border-radius: 4px; cursor: pointer; font-size: 13px; display: flex; align-items: center; justify-content: center; }
.page-btn:hover:not(.disabled) { border-color: #8b5cf6; color: #8b5cf6; }
.page-btn.active { background: #8b5cf6; border-color: #8b5cf6; color: #fff; }
.page-btn.disabled { cursor: not-allowed; opacity: 0.5; }
.pagination-btn { width: 32px; height: 32px; padding: 0; display: flex; align-items: center; justify-content: center; }
.page-size-selector { display: flex; align-items: center; gap: 5px; font-size: 13px; }
.page-size-input { width: 70px; padding: 4px 8px; }

.action-cell .btn-xs { margin: 0 2px; padding: 4px 8px; font-size: 11px; border-radius: 4px; cursor: pointer; border: 1px solid transparent; }
.btn-info.btn-xs { background: #3498db; color: #fff; }
.btn-danger.btn-xs { background: #e74c3c; color: #fff; }

.btn { padding: 6px 14px; border: 1px solid transparent; border-radius: 4px; font-size: 13px; cursor: pointer; display: inline-flex; align-items: center; gap: 4px; transition: all 0.2s; }
.btn-primary { background: #8b5cf6; color: #fff; border-color: #8b5cf6; }
.btn-primary:hover { background: #7c3aed; }
.btn-default { background: #fff; color: #374151; border-color: #d1d5db; }
.btn-default:hover { background: #f9fafb; }
.btn-sm { padding: 5px 10px; font-size: 12px; }
</style>
